module.exports = __webpack_public_path__ + "media/images/heroslider3-fda7f80be2266bb01146d34acc35c4b7.jpg";